$('#diagnostico_consulta').autoComplete({
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/diagnosticoAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});